import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RiderService } from 'app/services';
import { XpressDisciplinaryActionEnum, XpressDisciplinaryReasonsModel, XpressDisciplinaryHearingLocationsModel } from 'app/models';
import { cl } from '@fullcalendar/core/internal-common';

@Component({
    selector: 'add-hearing-or-reason-disciplinary',
    templateUrl: './add-hearing-or-reason-disciplinary.component.html',
    styleUrls: ['./add-hearing-or-reason-disciplinary.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})
export class AddHearingOrReasonComponent implements OnInit {
    @Input() disciplinaryActionId!: XpressDisciplinaryActionEnum;

    @Input() public displayModalAddHearingOrReason: boolean = false;

    @Input() public hearingOrReasonTitle!: string;
    @Input() public hearingOrReasonDescription!: string;

    @Output() changedDisplayModalAddHearingOrReasonEmit = new EventEmitter<any>();
    changeDisplayModalAddHearingOrReason(increased: any) {
        this.changedDisplayModalAddHearingOrReasonEmit.emit(increased);
    }

    public data: any = {
        reasonId: null,
        reason: null,
        hearingLocationId: null,
        hearingDateTime: null,
        hearingTime: null
    };

    public disciplinaryActionEnum = XpressDisciplinaryActionEnum;
    public disciplinaryReasonsList = XpressDisciplinaryReasonsModel.XpressDisciplinaryReasonsList;
    public disciplinaryActionList = XpressDisciplinaryHearingLocationsModel.XpressDisciplinaryActionList;

    public loading: boolean = false;

    constructor(
        private messageService: MessageService,
        private riderService: RiderService
    ) { }

    ngOnInit(): void { }

    submit() {
        this.loading = true;
        if (this.disciplinaryActionId === XpressDisciplinaryActionEnum.Closed && this.data.reasonId && this.data.reason) {
            this.changeDisplayModalAddHearingOrReason({ data: this.data, displayModalAddHearingOrReason: false });
        }
        else if ((this.disciplinaryActionId === XpressDisciplinaryActionEnum.Suspension ||
            this.disciplinaryActionId === XpressDisciplinaryActionEnum.Ban) && this.data.hearingLocationId && this.data.hearingDateTime && this.data.hearingTime) {
            this.data.hearingDateTime.setHours(this.data.hearingTime.getHours());
            this.data.hearingDateTime.setMinutes(this.data.hearingTime.getMinutes());
            this.changeDisplayModalAddHearingOrReason({ data: this.data, displayModalAddHearingOrReason: false });
        }
        else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Fields is required' });
        }
        this.loading = false;
    }

    cancel() {
        this.changeDisplayModalAddHearingOrReason({ data: null, displayModalAddHearingOrReason: false });
    }
}
